module.exports = __webpack_public_path__ + "static/media/icon-gutschein.aaadce03.svg";